import { render, staticRenderFns } from "./starTable.vue?vue&type=template&id=63231f20&scoped=true&"
import script from "./starTable.vue?vue&type=script&lang=js&"
export * from "./starTable.vue?vue&type=script&lang=js&"
import style0 from "./starTable.vue?vue&type=style&index=0&id=63231f20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63231f20",
  null
  
)

export default component.exports